import * as XLSX from "xlsx";
import CryptoJS from "crypto-js";
import {message, Upload} from "antd";

export const downloadFileHandle = (data, filename) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");
  XLSX.writeFile(workbook, `${filename || "data"}.xlsx`);
};

export const decryptCredentials = (encryptedSalt, hashedPassword) => {
  const commonSalt = process.env.REACT_APP_DECRYPT_PASSWORD;

  if (!encryptedSalt || !hashedPassword) {
    return "";
  }

  try {
    // Step 1: Decrypt the salt
    const decryptedSaltBytes = CryptoJS.AES.decrypt(encryptedSalt, commonSalt);
    const decryptedSalt = decryptedSaltBytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedSalt) {
      return "";
    }

    // Step 2: Use decrypted salt to decrypt the password
    const decryptedPasswordBytes = CryptoJS.AES.decrypt(hashedPassword, decryptedSalt);
    const decryptedPassword = decryptedPasswordBytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedPassword) {
      return "";
    }

    return decryptedPassword;
  } catch (error) {
    console.error("❌ Error decrypting credentials:", error);
    return "";
  }
};

export const fileSizeValidation = (file) => {
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
      message.error('File must be smaller than 2MB!');
      return Upload.LIST_IGNORE;
    }
    return false;
}

/**
 * Returns the appropriate login route based on user role
 * @param {Object} user - The user object containing role and other properties
 * @returns {string} - The login route path
 */
export const getLoginRoute = (user) => {
  if (!user) {
    return '/login/admin';
  }

  switch (user.role) {
    case 'ADMIN':
      return '/login/admin';
    case 'SUBADMIN':
      return '/login/subadmin';
    case 'WHITE_LABEL':
      return '/login/white_label';
    case 'MMP_ADMIN':
        return '/login/mmpadmin';
    case 'CUSTOMER':
      // If customer has a white label, include it in the route
      if (user.white_label) {
        return `/login/customer?white_label=${user.white_label}`;
      }
      return '/login/customer';
    default:
      return '/login/admin';
  }
}; 